/**
 * 게시판 목록 컴포넌트
 */

import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../styles/theme';
import { mediaQueries } from '../../../constants/breakpoints';
import { BoardListItem } from '../../../types/board.types';
import { Card } from '../../UI';

interface BoardListProps {
  posts: BoardListItem[];
  onPostClick: (postId: number) => void;
}

const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: ${theme.spacing.lg};
  padding: ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    grid-template-columns: 1fr;
    padding: ${theme.spacing.md};
  }
`;

const PostCard = styled(Card)`
  cursor: pointer;
`;

const PostImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: ${theme.borderRadius.md};
  margin-bottom: ${theme.spacing.md};
`;

const PostTitle = styled.h3`
  font-size: ${theme.fontSizes.lg};
  font-weight: 700;
  margin-bottom: ${theme.spacing.md};
  color: ${theme.colors.text};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const PostMeta = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.textLight};
`;

const EmptyMessage = styled.div`
  text-align: center;
  padding: ${theme.spacing.xxxl};
  color: ${theme.colors.textLight};
  font-size: ${theme.fontSizes.lg};
`;

export const BoardList: React.FC<BoardListProps> = ({ posts, onPostClick }) => {
  if (posts.length === 0) {
    return <EmptyMessage></EmptyMessage>;
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  const getImageUrl = (imageUrl?: string) => {
    return imageUrl || '/images/default-board-thumbnail.jpg';
  };

  return (
    <ListContainer>
      {posts.map((post) => (
        <PostCard key={post.id} onClick={() => onPostClick(post.id)} hoverable>
          <PostImage src={getImageUrl(post.mainImageUrl)} alt={post.title} />
          <PostTitle>{post.title}</PostTitle>
          <PostMeta>
            <span>{formatDate(post.createdAt)}</span>
            <span>조회 {post.views}</span>
          </PostMeta>
        </PostCard>
      ))}
    </ListContainer>
  );
};
